import MuiBox from '@mui/material/Box'
import { styled } from '@mui/material'

const Box = styled(MuiBox)`
  background-color: ${({ theme }) => theme.palette.success.main};
  min-width: 16px;
  min-height: 16px;
  border-radius: 50%;
  border: 2px solid white;
  box-sizing: border-box;
`

export function OnlineBadge() {
  return <Box />
}
// 68D200
